import { Reveal } from "@/components/Reveal";

export const Chapter = ({ id, number, label, title, testid, dark = false, children, className = "" }) => (
    <section
        id={id}
        data-testid={testid}
        className={`relative overflow-hidden py-20 lg:py-32 ${dark ? "bg-night text-ivory" : ""} ${className}`}
    >
        <span
            aria-hidden
            className={`pointer-events-none absolute -top-6 right-4 select-none font-serif text-[10rem] leading-none lg:text-[17rem] ${
                dark ? "text-ivory/[0.04]" : "text-wood/[0.05]"
            }`}
        >
            {number}
        </span>
        <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-start gap-8 px-6 sm:px-12 lg:grid-cols-12 lg:gap-16 lg:px-20">
            <Reveal className="lg:col-span-4">
                <div className="flex items-center gap-4">
                    <span className={`font-mono text-sm ${dark ? "text-gold" : "text-terra"}`}>{number}</span>
                    <span className={`h-px w-10 ${dark ? "bg-gold/50" : "bg-terra/50"}`} />
                    <span
                        className={`text-xs uppercase tracking-[0.25em] ${
                            dark ? "text-ivory/50" : "text-timber"
                        }`}
                    >
                        {label}
                    </span>
                </div>
            </Reveal>
            <div className="lg:col-span-8">
                <Reveal delay={0.1}>
                    <h2 className="font-serif text-2xl font-normal leading-snug tracking-tight sm:text-3xl lg:text-4xl">
                        {title}
                    </h2>
                </Reveal>
                <div className="mt-8">{children}</div>
            </div>
        </div>
    </section>
);
